// extracted by mini-css-extract-plugin
export var bestOption = "product-best-options-module--bestOption--6a3a7";
export var buttons = "product-best-options-module--buttons--3524c";
export var cardContainer = "product-best-options-module--cardContainer--9e22d";
export var description = "product-best-options-module--description--81153";
export var genericContainer = "product-best-options-module--genericContainer--6ada9";
export var gridContainer = "product-best-options-module--gridContainer--ea41f";
export var gridStaticContainer = "product-best-options-module--gridStaticContainer--3c680";
export var listContainer = "product-best-options-module--listContainer--7e3af";
export var name = "product-best-options-module--name--6b0fd";
export var productImg = "product-best-options-module--productImg--4b891";
export var refButton = "product-best-options-module--refButton--580ec";
export var title = "product-best-options-module--title--8fa68";
export var titleContainer = "product-best-options-module--titleContainer--209be";
export var visitButton = "product-best-options-module--visitButton--651de";